import { UnknownAction } from "@reduxjs/toolkit";
import { CORE_ACTION } from "./types/CoreAction";
import { CoreState } from "./types/CoreState";
import { DownloadSnackBarProps } from "@modules/shared/DownloadSnackBarProvider/DownloadSnackBar";

const initState = {
  user: {},
  theme: "GENERALI",
  dialog: {
    open: false,
  },
  downloadSnackBars: [],
};

const coreReducer = (state = initState, action: UnknownAction) => {
  const payload = action.payload as Partial<CoreState>;

  switch (action.type) {
    case CORE_ACTION.UPDATE:
      // new state
      return { ...state, ...payload };
    case CORE_ACTION.UPDATE_THEME:
      // new state
      return { ...state, theme: payload.theme };
    case CORE_ACTION.UPDATE_DIALOG:
      return {
        ...state,
        dialog: { ...state.dialog, ...payload.dialog, open: true },
      };
    case CORE_ACTION.CLOSE_DIALOG:
      return { ...state, dialog: { open: false } };
    case CORE_ACTION.ADD_DOWNLOAD_SNACK:
      return {
        ...state,
        downloadSnackBars: [...(state.downloadSnackBars || []), action.payload],
      };
    case CORE_ACTION.REMOVE_DOWNLOAD_SNACK:
      return {
        ...state,
        downloadSnackBars: (state.downloadSnackBars || []).filter(
          (snack: DownloadSnackBarProps) => snack.id !== action.payload,
        ),
      };
    case CORE_ACTION.UPDATE_DOWNLOAD_SNACK:
      return {
        ...state,
        downloadSnackBars: (state.downloadSnackBars || []).map(
          (snack: DownloadSnackBarProps) =>
            snack.id === (action.payload as DownloadSnackBarProps).id
              ? { ...snack, ...(action.payload as DownloadSnackBarProps) }
              : snack,
        ),
      };
    case CORE_ACTION.RESET:
      return initState;
    default:
      // same state
      return state;
  }
};

export default coreReducer;
